//TODO: opt
import { UI_URL } from 'constants/application';
import routes from 'constants/routes';

export const getISODateFromToday = days => new Date(+new Date() + days * 86400000).toISOString().split('T')[0];

export const getShareLink = token => `${UI_URL}${routes.SHARED_LIST.replace(':token', token)}`;
